module.exports = __webpack_public_path__ + "static/img/rahul_sir.f3427311.png";